import {
  Button,
  Container,
  createStyles,
  Group,
  Paper,
  Text,
  Title,
} from "@mantine/core";
import { Dots } from "./dots";

const useStyles = createStyles((theme) => ({
  wrapper: {
    position: "relative",
    paddingTop: 60,
    paddingBottom: 80,

    "@media (max-width: 755px)": {
      paddingTop: 80,
      paddingBottom: 60,
    },
  },

  inner: {
    position: "relative",
    zIndex: 1,
  },

  dots: {
    position: "absolute",
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[5]
        : theme.colors.gray[1],

    "@media (max-width: 755px)": {
      display: "none",
    },
  },

  dotsLeft: {
    left: 0,
    top: 0,
  },

  title: {
    textAlign: "center",
    fontWeight: 800,
    fontSize: 40,
    letterSpacing: -1,
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    marginBottom: theme.spacing.xs,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    "@media (max-width: 520px)": {
      fontSize: 28,
      textAlign: "left",
    },
  },

  highlight: {
    color:
      theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 6],
  },

  description: {
    textAlign: "center",

    "@media (max-width: 520px)": {
      textAlign: "left",
      fontSize: theme.fontSizes.md,
    },
  },

  controls: {
    marginTop: theme.spacing.lg,
    display: "flex",
    justifyContent: "center",

    "@media (max-width: 520px)": {
      flexDirection: "column",
    },
  },

  control: {
    "&:not(:first-of-type)": {
      marginLeft: theme.spacing.md,
    },

    "@media (max-width: 520px)": {
      height: 42,
      fontSize: theme.fontSizes.md,

      "&:not(:first-of-type)": {
        marginTop: theme.spacing.md,
        marginLeft: 0,
      },
    },
  },
}));

export function HeroText() {
  const { classes } = useStyles();

  return (
    <Container className={classes.wrapper} size={700}>
      <Dots className={classes.dots} style={{ left: 0, top: 0 }} />
      <Dots className={classes.dots} style={{ left: 60, top: 0 }} />
      <Dots className={classes.dots} style={{ left: 0, top: 140 }} />
      <Dots className={classes.dots} style={{ right: 0, top: 60 }} />

      <Paper className={classes.inner}>
        <Title className={classes.title}>
          =={" "}
          <Text component="span" className={classes.highlight} inherit>
            WorldCup22 ⚽
          </Text>{" "}
          ==
        </Title>

        <Container p={0} size={600}>
          <Text size="lg" color="dimmed" className={classes.description}>
            Limited-time betting game. Win big, degens!
          </Text>
        </Container>

        <Group className={classes.controls}>
          <Button
            component="a"
            href="https://world-cup-22.gitbook.io/"
            target="_blank"
            className={classes.control}
            size="lg"
            variant="default"
            color="gray"
            leftIcon={"📚"}
          >
            Read Docs
          </Button>
          <Button
            component="a"
            href="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x959b97Dfaa4b4785Bf3A31e52DdF583444137583&exactAmount=0.1"
            target="_blank"
            className={classes.control}
            size="lg"
            leftIcon={"🦄"}
          >
            Buy Tokens
          </Button>
        </Group>
      </Paper>
    </Container>
  );
}
